<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :model="model"
    :save-endpoint="saveEndpoint"
    :readonly="readonly"
    :after-save="afterSave"
  >
    <template #form v-if="model">
      <form-section>
        <el-row>
          <el-col :span="12">
            <rest-form-item
              prop="open_live_activities_batch_size"
              :label="
                $t('ProjectSettings_Field_Open_Live_Activities_Batch_Size')
              "
              :description="
                $t('ProjectSettings_Field_Open_Live_Activities_Batch_Size_Desc')
              "
            >
              <el-input-number
                v-model="model.open_live_activities_batch_size"
                :min="0"
                :max="10000"
                data-qa="open-live-activities-batch-size-feature-flag"
              />
            </rest-form-item>
          </el-col>
          <el-col :span="12">
            <rest-form-item
              prop="open_live_activities_auditlog_retention_period_days"
              :label="$t('DataRetention_Field_LiveActivityAuditLog')"
              :description="$t('DataRetention_Field_LiveActivityAuditLog_Hint')"
              data-qa="live-activity-auditlog-form-item"
            >
              <el-input-number
                v-model="
                  model.open_live_activities_auditlog_retention_period_days
                "
                :placeholder="
                  $t('DataRetention_Field_LiveActivityAuditLog_Placeholder')
                "
                :min="0"
                :max="180"
                data-qa="live_activity_auditlog_retention_period_days"
              />
            </rest-form-item>
          </el-col>
        </el-row>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import RestFormPage from '@/common/components/rest/RestFormPage.vue'
import { projectEndpoint } from '@/core/helpers'
import FormSection from '@/common/components/form/FormSection.vue'
import RestFormItem from '@/common/components/rest/RestFormItem.vue'

export default {
  name: 'OpenLiveActivitiesSettingsPage',

  components: {
    RestFormItem,
    FormSection,
    RestFormPage
  },

  data() {
    return {
      model: {}
    }
  },

  methods: {
    afterSave(res, loading) {
      this.$store.dispatch('reloadProjectConfig').then(loading())
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: ``,
        params: {
          fields:
            'open_live_activities_batch_size,open_live_activities_auditlog_retention_period_days'
        },
        handler: data => {
          this.model = data
        }
      })
    },
    saveEndpoint() {
      return projectEndpoint({
        method: 'patch',
        url: ``,
        params: {
          data: this.model
        }
      })
    },
    readonly() {
      return !this.$isRole('admin')
    },
    pageTitle() {
      return this.$t(this.$route.meta.title)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/pages/OpenLiveActivitiesSettingsPage.vue